/**
 * @desc 清空缓存
 */
const URL = "/rantion-activiti";
import http, { updateResponse } from "@/http";
export type Response = defs.activiti.Response;
export function request(options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/simpleTodoLinks/clearCache`, {
      method: "POST",

      ...options,
    }),
  );
}
